/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type MatchupAdvantageTableQueryVariables = {||};
export type MatchupAdvantageTableQueryResponse = {|
  +nflOffensiveMatchupRankings: ?$ReadOnlyArray<?{|
    +team: {|
      +abbreviation: string,
      +name: ?string,
    |},
    +opp: {|
      +abbreviation: string,
      +name: ?string,
    |},
    +teamTotal: any,
    +gameTotal: any,
    +passGameRank: number,
    +runGameRank: number,
    +onslaughtRank: number,
  |}>
|};
export type MatchupAdvantageTableQuery = {|
  variables: MatchupAdvantageTableQueryVariables,
  response: MatchupAdvantageTableQueryResponse,
|};
*/


/*
query MatchupAdvantageTableQuery {
  nflOffensiveMatchupRankings {
    team {
      abbreviation
      name
      id
    }
    opp {
      abbreviation
      name
      id
    }
    teamTotal
    gameTotal
    passGameRank
    runGameRank
    onslaughtRank
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "abbreviation",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamTotal",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gameTotal",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "passGameRank",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "runGameRank",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "onslaughtRank",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = [
  (v0/*: any*/),
  (v1/*: any*/),
  (v8/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MatchupAdvantageTableQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NFLOffensiveMatchupRankingsType",
        "kind": "LinkedField",
        "name": "nflOffensiveMatchupRankings",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatTeamType",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatTeamType",
            "kind": "LinkedField",
            "name": "opp",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MatchupAdvantageTableQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NFLOffensiveMatchupRankingsType",
        "kind": "LinkedField",
        "name": "nflOffensiveMatchupRankings",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatTeamType",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NFLStatTeamType",
            "kind": "LinkedField",
            "name": "opp",
            "plural": false,
            "selections": (v9/*: any*/),
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fe3fa59fdd04561c73aef7847dc7e7e6",
    "id": null,
    "metadata": {},
    "name": "MatchupAdvantageTableQuery",
    "operationKind": "query",
    "text": "query MatchupAdvantageTableQuery {\n  nflOffensiveMatchupRankings {\n    team {\n      abbreviation\n      name\n      id\n    }\n    opp {\n      abbreviation\n      name\n      id\n    }\n    teamTotal\n    gameTotal\n    passGameRank\n    runGameRank\n    onslaughtRank\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1f81fb189615b036ae403d2c5c0fbb5b';

module.exports = node;
